import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiValidatingFormDirective } from './fi-validating-form.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [FiValidatingFormDirective],
    exports: [FiValidatingFormDirective],
})
export class FiValidatingFormModule {}
